import { Link } from "react-router-dom";
import Header from "../../layouts/AuthLayout/header/header";
import OrderSection from "./order-details-section";

export default function OrderDetailsPage() {
  return (
    <>
      {/* Header start  */}
      <Header />
      {/* Header End  */}

      {/* Ec breadcrumb start */}
      <div className="sticky-header-next-sec  ec-breadcrumb section-space-mb">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row ec_breadcrumb_inner">
                <div className="col-md-6 col-sm-12">
                  <h2 className="ec-breadcrumb-title">Order</h2>
                </div>
                <div className="col-md-6 col-sm-12">
                  {/* ec-breadcrumb-list start */}
                  <ul className="ec-breadcrumb-list">
                    <li className="ec-breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="ec-breadcrumb-item active">Order</li>
                  </ul>
                  {/* ec-breadcrumb-list end */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Ec breadcrumb end */}
      <OrderSection />
    </>
  );
}
